export const userMapper = {
  name: 'name',
  last_name: 'last_name',
  tlf: 'tlf',
  email: 'email',
  image: 'image',
  modules: 'profile.modules'
};
